import { alpha } from "@mui/material";
import { width } from "@mui/system";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: 1.2,
  },
  avatar: {
    width: 56,
    height: 56,
    borderRadius: "14px",
    backgroundColor: alpha(theme.palette.text.secondary, 0.15),
  },
  dropzone: {
    flex: 1,
    border: `1.5px dashed ${alpha(theme.palette.primary.main, 0.4)}`,
    borderRadius: "12px",
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    transition: "background-color .15s ease, border-color .15s ease",
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
    },
  },
  dropzoneActive: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    borderColor: theme.palette.primary.main,
  },
  dropzoneText: {
    fontSize: "0.78rem",
    color: theme.palette.text.secondary,
  },
  removeButton: {
    color: theme.palette.colors.red.medium,
  },
  adjustContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: 1,
  },
  adjustAlert: {
    borderRadius: "10px",
    fontSize: "0.75rem",
    fontWeight: 500,
    py: 0.25,
    "& .MuiAlert-message": {
      padding: "4px 0",
    },
  },
  cropArea: {
    position: "relative",
    width: "100%",
    height: "160px",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: theme.palette.mode === "dark" ? "#1c1c1c" : "#333333",
  },
  zoomRow: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  zoomIcon: {
    color: theme.palette.text.secondary,
  },
  adjustActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
    flexWrap: "wrap",
    "@media (max-width: 480px)": {
      flexDirection: "column-reverse",
    },
  },
  adjustCancelButton: {
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
  adjustConfirmButton: {
    fontWeight: 600,
    boxShadow: `0 2px 8px ${alpha(theme.palette.success.main, 0.35)}`,
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
});

export default styles;
